module.exports = __webpack_public_path__ + "img/Hamsun_Nazismen.589dda20.jpg";